export enum StripeIdentityVerificationFlowStatus {
  PENDING = "pending",
  FAILED = "failed",
  CANCELED = "canceled",
  COMPLETED = "completed",
}
